export const environment: any = {
  "production": true,
  "API": "https://api.rushmypassport.com/api/",
  "client_url": "https://my.govworks.com",
  "visas": true,
  "header": {
    "logo": "assets/svg/rmp_dark.svg"
  },
  "support": {
    "phone": "8335678976",
    "email": "info@rushmypassport.com",
    "label": ""
  },
  "login": {
    "enabled": false,
    "logo": "assets/svg/rmp_dark.svg"
  },
  "terms": {
    "website_url": "https://www.rushmypassport.com",
    "website": "www.rushmypassport.com",
    "website_name": "RushMyPassport.com",
    "website_email": "info@rushmypassport.com"
  },
  "legal_links": {
    "terms": "/terms-of-use",
    "privacy": "/privacy-policy",
    "refund": "/refund-policy"
  },
  "source": {
    "domain": "aarp",
    "main_website": "",
    "promo_code": false,
    "name": "AARP",
    "auto_applied_code": "660958f8df5b"
  },
  "slides": {
    "passport": [
      {
        "title": "Select Service Type and Place Your Order",
        "hide_index": true, 
        "icon": {
          "name": "step_1",
          "width": "90px",
          "height": "90px"
        },
        "elements": [
          "Select passport service and indicate how quickly you need it.",
          "Expediting cost does not include shipping fees or government fees, which are paid separately to the U.S. Department of State (starting at $190 for adults and $160 for children)."
        ]
      },
      {
        "title": "Complete and Print Your Application Packet",
        "hide_index": true, 
        "icon": {
          "name": "step_2",
          "width": "90px",
          "height": "90px"
        },
        "elements": [
          "After placing your order, you will be directed to govWorks to begin your application.",
          "The user-friendly, online wizard will generate the required documents.",
          "Review and print your personalized packet and checklist."
        ]
      },
      {
        "title": "Get a New Passport Photo",
        "hide_index": true, 
        "icon": {
          "name": "step_3",
          "width": "90px",
          "height": "90px"
        },
        "elements": [
          "Every passport application requires a printed government-compliant photo.",
          "Option A: Get a new passport photo at a retail location near you.",
          "Option B: <a href='https://www.passportphotocreator.com/' target='_blank'>Download the Passport Photo Creator app</a> and print at a local Walgreens."
        ]
      },
      {
        "title": "Gather Your Documents for Submission",
        "hide_index": true, 
        "icon": {
          "name": "step_4",
          "width": "90px",
          "height": "90px"
        },
        "elements": [
          "Review your checklist to ensure you have all required documents.",
          "Follow the submission instructions in your checklist.",
          "Some services will not require a FedEx shipping label and are shipped through the <a href='#adjudication'>Adjudication process</a> with a Passport Acceptance Agent."
        ]
      }
    ]
  },
  "footer": {
    "logo": "assets/svg/rmp_dark.svg",
    "logo_link": "/",
    "copyright": "RushMyPassport.com, LLC",
    "footer_disclaimer": "AARP member benefits are provided by third parties, not by AARP or its affiliates. Providers pay royalty fees to AARP for the use of its intellectual property. These fees are used for the general purposes of AARP. Some provider offers are subject to change and may have restrictions. Please contact the provider directly for details."
  },
  "landing_pages": {
    "passport": {
      "title": "AARP | Passport Expediting",
      "enabled": true,
      "variation": 3,
      "compact_signin": true, 
      "hide_banner": true,
      "signin": "<div style=\"border-bottom: 1px solid lightgrey; padding-bottom: 20px; line-height: 1.4; font-size: 18px;\">Returning Customer?<br/>Sign in to our secure portal to check your application.</div>",
      "signin_btn": "Track My Order",
      "bg": "https://govworks-email-assets.s3.us-east-1.amazonaws.com/aarp_hero.jpg",
      "heading": "Exclusive Offer: 15% Off Passport & Visa Services<sup>*</sup>",
      "block_copy": "<h4>Expedited U.S. Passport Services for AARP Members Include:</h4><ul><li><strong>Flexible Service Options:</strong>  Expedited processing speeds for all U.S. passports and visas to meet your travel needs.</li><li><strong>Seamless Online Experience:</strong> Smart-form application to ensure accuracy and ease, providing you with peace of mind.</li><li><strong>Personalized Concierge Support:</strong> Dedicated support via phone, chat, email, or one-on-one video conferencing for additional support.</li></ul><a target=\"_blank\" href=\"https://appsec.aarp.org/mem/join?campaignId=FFKURUSH&cmp=ASI_P_MU_JN_RUSHMYPASSPORT\">Become&nbsp;an&nbsp;AARP&nbsp;member</a> | <a target=\"_blank\" href=\"https://appsec.aarp.org/mem/renew?campaignId=FFKURUSH&cmp=ASI_P_MU_RN_RUSHMYPASSPORT\">Renew&nbsp;your&nbsp;AARP&nbsp;membership</a>",
      "meta": {
        "description": "AARP members and their families have exclusive access to passport renewal bundles along with first-time, child, and replacement passports with RushMyPassport."
      },
      "links": [
        {
            "url": "/visas",
            "internal": true,
            "label": "Travel Visa Services",
            "mobile_label": "Travel Visas"
        }
    ],
      "subdescription": "<section class=\"gw-chkout__hidedesktop\"><div style=\"display: flex; align-items: center; line-height: 1.3\"><div style=\"min-width: 250px; font-size: 0.5em;\"><sup>*</sup>Savings applicable for RushMyPassport service fees only. Additional government fees and shipping are not eligible for AARP discounts.</div></div></section>",
      "description": "<section style=\"display: flex; flex-direction: column; align-items: center; gap: 10px; line-height: 1.3\"><img src=\"assets/svg/aarp_logo.svg\" style=\"align-self: unset; width: 100px;\" class=\"gw-chkout-home__aarp\"><div style=\"font-size: 22px; font-weight: 700; min-width: 250px\">AARP members—act now to save big and get travel-ready faster.<div class=\"gw-chkout__hidemobile\" style=\"font-size: 0.5em; margin: 0 0 12px 0;\"><sup>*</sup>Savings applicable for RushMyPassport service fees only. Additional government fees and shipping are not eligible for AARP discounts.</div></div></section>"
    },
    "visa": {
      "enabled": true,
      "title": "AARP | Visa Expediting",
      "variation": 3,
      "compact_signin": true, 
      "signin": "Returning Customer?",
      "signin_btn": "Track My Order",
      "bg": "https://govworks-email-assets.s3.us-east-1.amazonaws.com/aarp_hero.jpg",
      "heading": "Exclusive Offer: 15% Off Passport & Visa Services<sup>*</sup>",
      "meta": {
        "description": "AARP members and their families receive exclusive pricing on Business visas, tourist visas, and everything in between."
      },
      "links": [
        {
            "url": "/",
            "internal": true,
            "label": "Passport Services",
            "mobile_label": "Passport Services"
        }
    ],
      "description": "<section style=\"display: flex; flex-direction: column; align-items: center; gap: 10px;\"><img src=\"assets/svg/aarp_logo.svg\" style=\"align-self: unset; width: 100px;\" class=\"gw-chkout-home__aarp\"><div style=\"font-weight: 700; font-size: 22px; line-height: 1.3;\">AARP members—act now to save big and get travel-ready faster.<div style=\"font-size: 0.5em; margin: 0 0 12px 0;\"><sup>*</sup>Savings applicable for RushMyPassport service fees only. Additional government fees and shipping are not eligible for AARP discounts.</div><section style=\"font-weight: 700; font-size: 15px; display: flex; justify-content: center;\"><div><a target=\"_blank\"  style=\"color: #FFFFFF;\" href=\"https://appsec.aarp.org/mem/join?campaignId=FFKURUSH&cmp=ASI_P_MU_JN_RUSHMYPASSPORT\">Become an AARP member</a> | <a target=\"_blank\"  style=\"color: #FFFFFF;\" href=\"https://appsec.aarp.org/mem/renew?campaignId=FFKURUSH&cmp=ASI_P_MU_RN_RUSHMYPASSPORT\">Renew your AARP membership</a></div></section></div></section>"
    },
    "root_type": "passport"
  },
  "fedex_logo": true,
  "create_lead": true, 
  "seals": {
    "truste": "170aae01-cd7c-4ad6-9007-5894464c0962"
  },
  "summary_cta_icon": true,
  "locations_page": {
    "enabled": false
  },
  "tags": {
    "mouseflow": "a4b10d95-cf95-4ba3-a395-3c78a36837ce",
    "tag_manager": "GTM-NNLNFVF",
    "ga4": ["G-5S9MVF86SJ", "G-JWNCRFK1BW"]
  }
};